// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"67c8d1cd","107":"bcf8f226","118":"bea64cbf","254":"a36c6354","319":"8d4b1db6","732":"d472fcd2","846":"f72af78c","870":"70c15559","937":"54682cf3","987":"21e32146"}[chunkId] + ".chunk.js";
};